// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1VsQl","row":"ProcedureTreatmentSummary_row__O8SIC"};